module.exports = __webpack_public_path__ + "static/img/partner15.b29cfac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner15.png
// module id = WiIP
// module chunks = 0